import React from 'react'
import Banner from '../components/Banner/Banner';
import Features from '../components/Features/Features';
import GalleryComponent from '../components/Gallery/GalleryComponent';
import TravelThemes from '../components/TravelThemes/TravelThemes';
import Tours from '../components/Tours/Tours';
import Contact from '../components/Contact/Contact';
import Testimonial from '../components/Testimonial/Testimonial';
// import About from './components/About us/About';






const Home = () => {
  return (
    <>
    <Banner/>
 
    <Features/>
  
       <GalleryComponent/>
<TravelThemes/>
<Tours/>
<Testimonial/>
<Contact/>
       
    </>
  )
}

export default Home;
